<template>
  <div
    class="embed-video"
    :class="{
      'embed-responsive embed-responsive-16by9': !isMp4,
      'embed-video--mp4': isMp4,
      'embed-video--cover': isMp4 && fitMode === 'cover',
      'embed-video--contain': isMp4 && fitMode !== 'cover',
    }"
  >
    <video
      v-if="isMp4"
      class="embed-video__media"
      :autoplay="autoplayEnabled"
      :muted="mutedEnabled"
      :loop="repeatEnabled"
      :controls="controlsEnabled"
      :playsinline="true"
      preload="metadata"
    >
      <source :src="src" type="video/mp4" />
    </video>
    <iframe
      v-else
      class="embed-responsive-item"
      :src="src"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    autoplay: {
      type: [Boolean, String],
      default: false,
    },
    muted: {
      type: [Boolean, String],
      default: true,
    },
    repeat: {
      type: [Boolean, String],
      default: false,
    },
    controls: {
      type: [Boolean, String],
      default: false,
    },
    fit: {
      type: String,
      default: "contain",
    },
  },
  computed: {
    isMp4() {
      return /\.mp4($|\?)/i.test(`${this.src || ""}`);
    },
    autoplayEnabled() {
      return this.normalizeBoolean(this.autoplay);
    },
    mutedEnabled() {
      return this.normalizeBoolean(this.muted, true);
    },
    repeatEnabled() {
      return this.normalizeBoolean(this.repeat);
    },
    controlsEnabled() {
      return this.normalizeBoolean(this.controls);
    },
    fitMode() {
      return `${this.fit || "contain"}`.toLowerCase() === "cover"
        ? "cover"
        : "contain";
    },
  },
  methods: {
    normalizeBoolean(value, defaultValue = false) {
      if (value === undefined || value === null || value === "") {
        return defaultValue;
      }
      if (typeof value === "boolean") return value;
      const normalized = `${value}`.toLowerCase().trim();
      return ["true", "1", "yes", "si", "on"].includes(normalized);
    },
  },
};
</script>

<style scoped>
.embed-video--mp4 {
  position: relative;
  width: 100%;
  aspect-ratio: 9 / 16;
  background: #000;
  overflow: hidden;
  border-radius: 1rem;
}

.embed-video__media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.embed-video--contain .embed-video__media {
  object-fit: contain;
}

.embed-video--cover .embed-video__media {
  object-fit: cover;
}

@media (min-width: 768px) {
  .embed-video--mp4 {
    aspect-ratio: 16 / 9;
  }
}
</style>
